// src/App.js
import "./App.css";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/navbar/Navbar";
import Banner from "./components/banner/Banner";
import Services from "./components/services/Services";
import Footer from "./components/footer/Footer";
import Auth from "./pages/auth/Auth";
import DoctorRegister from "./pages/auth/DoctorRegister";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PatientDashboard from "./pages/patientDashboard/patientDashboard";
import Appointments from "./pages/appointments/appointments";
import DoctorCalendar from "./pages/appointments/DoctorCalendar";

// Home section version
import DoctorsSection from "./components/doctors/Doctors";

// Page version
import DoctorsPage from "./pages/doctors/doctors";
import DoctorProfile from "./pages/doctors/DoctorProfile";
import Consent from "./pages/Consent/Consent";
import Assessment from "./pages/assessment/assessment";
import MeetingDashboard from "./pages/meeting/MeetingDashboard";
import JoinMeeting from "./pages/JoinMeeting/JoinMeeting";
import CreateMeeting from "./pages/CreateMeeting/CreateMeeting";
import FichePatient from "./pages/FichePatient/FichePatient";

import AdminDashboard from "./pages/admin/AdminDashboard";
import UserList from "./pages/admin/UserList";
import AffectationList from "./pages/admin/AffectationList";
import ConsultationList from "./pages/admin/ConsultationList";

// ✅ correct case in path

function Home() {
  return (
    <>
      <Banner />
      <Services />
      <DoctorsSection />
      <Footer />
    </>
  );
}

function NotFound() {
  return <div>Not found</div>;
}

export default function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/doctor" element={<DoctorsPage />} />
        <Route path="/doctors/:id" element={<DoctorProfile />} />

        {/* Protected Patient Routes */}
        <Route element={<ProtectedRoute allowedRole="patient" />}>
          <Route path="/dashboard" element={<PatientDashboard />} />
          <Route path="/appointments" element={<Appointments />} />
          <Route path="/appointments/request" element={<CreateMeeting />} />
          <Route path="/assessment" element={<Assessment />} />
        </Route>

        {/* Protected Admin Routes */}
        <Route element={<ProtectedRoute allowedRole="admin" />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<UserList />} />
          <Route path="/admin/affectations" element={<AffectationList />} />
          <Route path="/admin/consultations" element={<ConsultationList />} />
        </Route>

        {/* Protected Doctor Routes */}
        <Route element={<ProtectedRoute allowedRole="doctor" />}>
          <Route path="/doctor/calendar" element={<DoctorCalendar />} />
          <Route path="/doctor/create-meeting" element={<CreateMeeting />} />
          <Route path="/fiche/:id" element={<FichePatient />} />
        </Route>

        {/* ✅ use lowercase route */}
        <Route path="/consent" element={<Consent />} />

        <Route path="/login" element={<Auth />} />
        <Route path="/register" element={<Auth />} />
        <Route path="/join-medical-team" element={<DoctorRegister />} />
        <Route path="/meetingdashboard" element={<MeetingDashboard />} />
        <Route path="/JoinMeeting" element={<JoinMeeting />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
